export const CONTACT_US_URL =
  'https://7330706.extforms.netsuite.com/app/site/crm/externalcasepage.nl?compid=7330706&formid=3&h=AAFdikaIPCruB8gZgzhH3KdOP2z8EcczgVYVQsWYUV-HS6TwIzs';
